import { NgModule } from '@angular/core';
import { TextureViewerComponent } from './texture-viewer.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { MdePopoverModule } from '../popover/popover.module';

@NgModule({
  declarations: [TextureViewerComponent],
  imports: [FuseSharedModule, ComponentsModule, DirectivesModule, MdePopoverModule],
  exports: [TextureViewerComponent],
})
export class TextureViewerModule {}
